var _defs, _path, _rect, _polygon, _polygon2, _polygon3, _polygon4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSuperiorAbraision(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 174.11 174.17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#696a6c;}.cls-2{fill:#5a595b;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M90.15,177.08A87.06,87.06,0,1,1,166.27,48h0A87,87,0,0,1,90.15,177.08ZM89.89,9.92a80.1,80.1,0,1,0,70.25,41.49h0a79.53,79.53,0,0,0-47.86-38.29A80.35,80.35,0,0,0,89.89,9.92Z",
    transform: "translate(-2.94 -2.92)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 24.2,
    y: 105.38,
    width: 121.14,
    height: 5.01
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "113.56 78.24 108.55 78.24 108.55 66.98 96.29 66.98 96.29 61.97 113.56 61.97 113.56 78.24"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "68.31 110.83 24.7 67.22 28.24 63.68 68.31 103.75 108.74 63.32 112.28 66.86 68.31 110.83"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "145.57 78.24 140.57 78.24 140.57 66.98 128.3 66.98 128.3 61.97 145.57 61.97 145.57 78.24"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "100.32 110.83 56.72 67.22 60.26 63.68 100.32 103.75 140.75 63.32 144.29 66.86 100.32 110.83"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuperiorAbraision);
export default __webpack_public_path__ + "static/media/superior-abraision.91cb59b9465d4e43812b07bf3d3fbc44.svg";
export { ForwardRef as ReactComponent };